import React, { useEffect, useState } from "react";
import { Header, Label, Image } from "semantic-ui-react";
import * as auth from "../../modules/Auth/_redux/authRedux";
import Pagination from "../../components/common/CommonPagination";
import { useDebounce } from "use-debounce";
import ProgressBar from "@ramonak/react-progress-bar";
import Add from "./add";
import DataTable from "react-data-table-component";
import Tooltip from "react-power-tooltip";
import { useLocation } from "react-router";
import UserProfilePlaceholder, {
  LetteredAvatarImageUrl,
} from "../../components/common/userProfilePlaceholder";

import Edit from "./edit";
import Preview from "./preview/index";
import Filters from "./listingFilter";

import { connect, useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../config/i18n/slice";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import { useHistory } from "react-router-dom";
import useDisplayFormattedText from "../../../hooks/useDisplayFormattedText";
import {
  ArrowLeft,
  ArrowRight,
  CloseIcon,
  DuedateIcon,
  FlagwithFilled,
  PlusIcon,
  SchedualWOIcon,
  SortIcon,
  WorkOrderIcon,
  WorkOrderIconBlue,
} from "../../../Assets/Icons/svg";
import {
  fetchAllWOData,
  fetchWOInitData,
  fetchWOWithFilter,
} from "../../../redux/reducers/workOrderReducer";
import Animation from "../../components/common/CustomLoader";
import { format } from "date-fns";
import _ from "lodash";
import { getUserData } from "../../config/sharedApi/peopleApis";
import { isPastDue, isStartDue } from "../../config/date-utils";

const WorkOrders = (props) => {
  const { userPermissions } = usePermissionsSimplified();
  const lang = useSelector((state) => state.i18n.lang);
  const history = useHistory();
  const { DisplayFormattedText } = useDisplayFormattedText();
  const dispatch = useDispatch();

  const [selectedDates, setSelectedDates] = useState([]);
  const [sortData, setSortData] = useState();

  const [filterOptions, setFilterOptions] = useState({
    serialNumber: "",
    people: [],
    teams: [],
    customers: [],
    locations: [],
    createdByUser: [],
    status: [],
    priority: [],
    orderType: [],
    categories: [],
  });

  const [totalPartCount, setTotalPartCount] = useState({});

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });

  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 633)
  );
  const [searchTitle, setSearchTitle] = useState("");
  const [debounceValue] = useDebounce(searchTitle, 500);
  const [loader, setloader] = useState(false);
  const [seriesEdit, setSeriesEdit] = useState(false);

  const t = useSelector(selectTranslations);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });
  const currentUserId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });

  const customStyles = {
    rows: {
      style: {
        height: "72px",
      },
    },
    headCells: {
      style: {
        paddingTop: "11px",
        paddingLeft: selectedLanguage == "en" ? "10px" : "0px", 
        paddingRight: selectedLanguage == "en" ? "0px" : "10px",
      },
    },
    cells: {
      style: {
        paddingLeft: selectedLanguage == "en" ? "10px" : "0px", 
        paddingRight: selectedLanguage == "en" ? "0px" : "10px",
        paddingTop: "19px",
        paddingBottom: "19px",
      },
    },
  };

  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIds = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIds.some((inv) => inv == location?.id)) {
        allIds.push(location?.id);
      }
    });

  const {
    data,
    allVendorData,
    isLoading: loading,
    error,
    initData,
    page,
    pageSize,
    total,
    initLoading,
  } = useSelector((state) => ({
    data: state.workOrder.WOData,
    allVendorData: state.workOrder.allWOData,
    isLoading: state.workOrder.isLoading,
    error: state.workOrder.error,
    initData: state.workOrder.WOInitData,
    page: state.workOrder.page,
    pageSize: state.workOrder.pageSize,
    total: state.workOrder.total,
    initLoading: state.workOrder.initLoading,
  }));

  /* The function `handleSort` sorts data based on a specified column and sort direction */
  const handleSort = async (column, sortDirection) => {
    setloader(true);
    const sort = [`${column.sortField}:${sortDirection}`];
    setSortData(sort);
    const sortedData = await dispatch(
      fetchWOWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        assignee: filterOptions.people,
        status: filterOptions.status,
        priority: filterOptions.priority,
        category: filterOptions.categories,
        customers: filterOptions.customers,
        locations: filterOptions.locations,
        dueDate: selectedDates,
        serialNumber: filterOptions.serialNumber,
        teams: filterOptions.teams,
        sort,
        role: role,
        allIds: [],
        currentUserId,
        orderType: filterOptions?.orderType,
      })
    );

    setloader(false);
  };

  /* The function `handleRemoveSorting` for remove sorts data */
  const handleRemoveSorting = async () => {
    setloader(true);

    // Assuming the select or represents the field to sort
    const sort = undefined;
    setSortData(sort);
    const sortedData = await dispatch(
      fetchWOWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        assignee: filterOptions.people,
        status: filterOptions.status,
        priority: filterOptions.priority,
        category: filterOptions.categories,
        customers: filterOptions.customers,
        locations: filterOptions.locations,
        dueDate: selectedDates,
        serialNumber: filterOptions.serialNumber,
        teams: filterOptions.teams,
        sort,
        role: role,
        allIds: [],
        currentUserId,
        orderType: filterOptions?.orderType,
      })
    );

    setloader(false);
  };

  /*
   * Table Fields
   */
  let columns = [
    {
      name: t.workOrders.table.ID,
      sortField: "countNumId",
      width: selectedLanguage === "en" ? "75px" : "107px",
      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.countId}
        </span>
      ),
    },
    {
      width: "30px",
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.orderType == "scheduled" ? (
            <span className={`${selectedLanguage == "en" ? "mr-1" : "ml-1"}`}>
              {" "}
              <SchedualWOIcon />
            </span>
          ) : null}
        </span>
      ),
    },
    {
      name: t.workOrders.table.title,

      sortField: "title",
      sortable: true,
      minWidth: "250px",
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {DisplayFormattedText(row?.attributes?.title, 25)}
        </span>
      ),
    },
    {
      minWidth: "131px",
      sortField: "status",
      name: t.workOrders.table.status,

      sortable: true,
      cell: (row) => {
        const workOrderStatus = statusOptions.find(
          (status) => status.value === row.attributes.status
        );

        return (
          <div
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
            className="d-flex align-items-center"
          >
            <Label
              circular
              empty
              size="small"
              color={workOrderStatus?.color || "#788ca5"}
            />
            <div>
              <span className="ml-2 mr-2 text-uppercase">
                {workOrderStatus?.label || t.common.na}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      name: t.workOrders.table.priority,

      sortField: "priority",
      sortable: true,
      minWidth: "107px",
      cell: (row) => {
        const PriorityStatus = priorityOptions.find(
          (status) => status.value === row.attributes.priority
        );

        return (
          <>
            <div className={` mt-0 ${row.attributes.priority}`}>
              <FlagwithFilled color={PriorityStatus?.color} />
              <span className="ml-3 mr-3">{PriorityStatus?.label} </span>
            </div>
          </>
        );
      },
    },
    {
      name: t.workOrders.table.assignees,
      minWidth: "91px",

      cell: (row) => {
        let assigneePeople = _.cloneDeep(row?.attributes?.people?.data || []);
        let primaryAssignee = _.cloneDeep(
          row?.attributes?.primaryAssignee?.data
        );

        if (row?.attributes?.primaryAssignee?.data) {
          if (assigneePeople?.length) {
            assigneePeople.unshift(primaryAssignee);
          } else {
            assigneePeople.push(primaryAssignee);
          }
        }

        let totalLength = assigneePeople?.length ? assigneePeople?.length : 0;
        if (assigneePeople?.length) {
          if (assigneePeople?.length < 3) {
            assigneePeople = assigneePeople.map((people, index) => {
              if (people?.attributes?.profileImage?.data?.attributes?.url) {
                {
                  return (
                    <Image
                      onClick={() => {
                        setTargetedData(row);
                        setTogglePreviw(true);
                      }}
                      avatar
                      title={
                        people.attributes.firstName +
                        " " +
                        people.attributes.lastName
                      }
                      src={`${people?.attributes?.profileImage?.data?.attributes?.url}`}
                      className={`profile-img ${
                        index !== 0 ? "overlapping" : "img-first"
                      }`}
                    />
                  );
                }
              } else {
                return (
                  <UserProfilePlaceholder
                    name={`${
                      people?.attributes?.firstName
                        ? people?.attributes?.firstName
                        : ""
                    } ${
                      people?.attributes?.lastName
                        ? people?.attributes?.lastName
                        : ""
                    }`}
                    width={"34px"}
                    height={"34px"}
                    right={index !== 0 ? "7px" : ""}
                    className={index == 0 ? "img-first" : ""}
                  />
                );
              }
            });
          } else {
            assigneePeople = assigneePeople.slice(0, 2).map((people, index) => {
              if (people?.attributes?.profileImage?.data?.attributes?.url) {
                {
                  return (
                    <Image
                      onClick={() => {
                        setTargetedData(row);
                        setTogglePreviw(true);
                      }}
                      avatar
                      title={
                        people.attributes.firstName +
                        " " +
                        people.attributes.lastName
                      }
                      src={`${people?.attributes?.profileImage?.data?.attributes?.url}`}
                      className={`profile-img ${
                        index !== 0 ? "number-avatar" : "number-avatar-second"
                      }`}
                    />
                  );
                }
              } else {
                return (
                  <UserProfilePlaceholder
                    name={`${
                      people?.attributes?.firstName
                        ? people?.attributes?.firstName
                        : ""
                    } ${
                      people?.attributes?.lastName
                        ? people?.attributes?.lastName
                        : ""
                    }`}
                    width={"34px"}
                    height={"34px"}
                    right={
                      selectedLanguage === "ar" && index !== 0
                        ? "0px"
                        : index === 0 && selectedLanguage === "en"
                        ? "-15px"
                        : "-9px"
                    }
                  />
                );
              }
            });
            assigneePeople.push(
              <Image
                avatar
                title={
                  row?.attributes?.people?.data
                    .slice(row?.attributes?.primaryAssignee?.data ? 1 : 2) // Get all remaining people
                    .map(
                      (people) =>
                        `${people?.attributes?.firstName || ""} ${people
                          ?.attributes?.lastName || ""}`
                    )
                    .join(", ") // Fallback text
                }
                className="more-profile"
                src={`https://ui-avatars.com/api/?name=${totalLength -
                  2}%2B&background=E4E6EA&bold=true&color=788CA5`}
              />
            );
          }
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviw(true);
              }}
              className={`multi-profile-container ${
                lang == "en" ? "" : "rtl-body"
              }`}
            >
              {assigneePeople}
            </div>
          );
        } else {
          return t.common.na;
        }
      },
    },
    {
      name: t.teams.add,
      minWidth: "91px",

      cell: (row) => {
        let assigneePeople = _.cloneDeep(row?.attributes?.teams?.data || []);

        let totalLength = assigneePeople?.length ? assigneePeople?.length : 0;
        if (assigneePeople?.length) {
          if (assigneePeople?.length < 3) {
            assigneePeople = assigneePeople.map((people, index) => {
              if (people?.attributes?.images?.data?.attributes?.url) {
                {
                  return (
                    <Image
                      onClick={() => {
                        setTargetedData(row);
                        setTogglePreviw(true);
                      }}
                      avatar
                      title={people.attributes.name}
                      src={`${people?.attributes?.images?.data?.attributes?.url}`}
                      className={`profile-img ${
                        index !== 0 ? "overlapping" : "img-first"
                      }`}
                    />
                  );
                }
              } else {
                return (
                  <UserProfilePlaceholder
                    name={`${people?.attributes?.name}`}
                    width={"34px"}
                    height={"34px"}
                    right={index !== 0 ? "7px" : ""}
                    className={index == 0 ? "img-first" : ""}
                  />
                );
              }
            });
          } else {
            assigneePeople = assigneePeople.slice(0, 2).map((people, index) => {
              if (people?.attributes?.images?.data?.attributes?.url) {
                {
                  return (
                    <Image
                      onClick={() => {
                        setTargetedData(row);
                        setTogglePreviw(true);
                      }}
                      avatar
                      title={people.attributes.name}
                      src={`${people?.attributes?.images?.data?.attributes?.url}`}
                      className={`profile-img ${
                        index !== 0 ? "overlapping" : "number-avatar-second"
                      }`}
                    />
                  );
                }
              } else {
                return (
                  <UserProfilePlaceholder
                    name={`${people?.attributes?.name}`}
                    width={"34px"}
                    height={"34px"}
                    right={
                      selectedLanguage === "ar" && index !== 0
                        ? "0px"
                        : index === 0 && selectedLanguage === "en"
                        ? "-15px"
                        : "-9px"
                    }
                  />
                );
              }
            });
            assigneePeople.push(
              <Image
                avatar
                title={row?.attributes?.teams?.data
                  .slice(2)
                  .map((people) => `${people?.attributes?.name}`)
                  .join(", ")}
                src={`https://ui-avatars.com/api/?name=${totalLength -
                  2}%2B&background=E4E6EA&bold=true&color=788CA5`}
                className="more-profile"
              />
            );
          }
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviw(true);
              }}
              className={`multi-profile-container ${
                lang == "en" ? "" : "rtl-body"
              }`}
            >
              {assigneePeople}
            </div>
          );
        } else {
          return t.common.na;
        }
      },
    },

    {
      sortField: "category",
      name: t.workOrders.table.category,

      sortable: true,
      minWidth: selectedLanguage == "en" ? "189px" : "223px",
      cell: (row) => {
        const categoryStatus = categoryOptions.find(
          (one) => one.value == row.attributes.category
        );

        return (
          <div>
            <span
              onClick={() => {
                setTargetedData(row);
                setTogglePreviw(true);
              }}
              className=""
            >
              {categoryStatus?.label
                ? DisplayFormattedText(categoryStatus?.label, 28)
                : t.common.na}
            </span>
          </div>
        );
      },
    },
    userPermissions?.customer?.view
      ? {
          name: t.workOrders.table.customer,
          minWidth: selectedLanguage == "en" ? "150px" : "160px",
          sortField: "customer.name",

          sortable: true,
          cell: (row) => (
            <span
              onClick={() => {
                setTargetedData(row);
                setTogglePreviw(true);
              }}
              className=""
            >
              {DisplayFormattedText(
                row?.attributes?.customer?.data?.attributes?.name,
                19
              ) || t.common.na}
            </span>
          ),
        }
      : null, // If the user doesn't have permission, don't render the column

    {
      sortField: "location.name",
      name: t.workOrders.table.location,
      minWidth: "170px",

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className=""
        >
          {DisplayFormattedText(
            row?.attributes?.location?.data?.attributes.name,
            18
          ) || t.common.na}
        </span>
      ),
    },
    {
      sortField: "startDate",
      name: t.workOrders.table.startDateTime,
      minWidth: selectedLanguage == "en" ? "182px" : "187px",
      sortable: true,
      cell: (row) => (
        <div
          className="d-flex start-date-div justify-content-center align-items-center"
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
        >
          {isStartDue(row?.attributes?.status, row?.attributes?.startDate) ? (
            <div>
              <>
                <DuedateIcon  />
              </>
            </div>
          ) : null}

          <div
            className={`${
              isStartDue(row?.attributes?.status, row?.attributes?.startDate)
                ? "text-danger mb-1"
                : "mb-1"
            } `}
          >
            <div>
              {" "}
              {row?.attributes?.startDate ? (
                <>
                  {format(
                    new Date(
                      row?.attributes?.startDate +
                        "T" +
                        `${row?.attributes?.startTime || "08:00:00"}`
                    ),
                    "dd/MM/yyyy hh:mm a"
                  )}
                </>
              ) : (
                <span>{t.common.na}</span>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      sortField: "dueDate",
      name: t.workOrders.table.dueDateTime,
      minWidth: selectedLanguage == "en" ? "182px" : "187px",

      sortable: true,
      cell: (row) => (
        <div
          className="d-flex start-date-div justify-content-center align-items-center"
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
        >
          {isPastDue(
            row?.attributes?.dueDate +
              "T" +
              `${row?.attributes?.dueTime || "08:00:00"}`,
            row?.attributes?.status
          ) ? (
            <div>
              <>
                <DuedateIcon />
              </>
            </div>
          ) : null}

          <div
            className={`${
              isPastDue(
                row?.attributes?.dueDate +
                  "T" +
                  `${row?.attributes?.dueTime || "08:00:00"}`,
                row?.attributes?.status
              )
                ? "text-danger mb-1"
                : "mb-1"
            } `}
          >
            <div>
              {" "}
              {row?.attributes?.dueDate ? (
                <>
                  {format(
                    new Date(
                      row?.attributes?.dueDate +
                        "T" +
                        `${row?.attributes?.dueTime || "08:00:00"}`
                    ),
                    "dd/MM/yyyy hh:mm a"
                  )}
                </>
              ) : (
                <span>{t.common.na}</span>
              )}
            </div>
          </div>
        </div>
      ),
    },

    {
      name: t.workOrders.table.createdByUser,
      minWidth: selectedLanguage == "en" ? "86px" : "107px",
      sortField: "createdByUser.firstName",

      sortable: true,
      cell: (row) => {
        let createdByUser = row?.attributes?.createdByUser?.data ? (
          <div
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
          >
            <Image
              avatar
              className="profile-img"
              title={
                row.attributes.createdByUser.data.attributes.firstName +
                " " +
                row.attributes.createdByUser.data.attributes.lastName
              }
              src={
                row?.attributes?.createdByUser?.data?.attributes?.profileImage
                  ?.data?.attributes?.url
                  ? row?.attributes?.createdByUser?.data?.attributes
                      ?.profileImage?.data?.attributes?.url
                  : LetteredAvatarImageUrl(
                      row?.attributes?.createdByUser?.data?.attributes
                        .firstName +
                        " " +
                        row?.attributes?.createdByUser?.data?.attributes
                          ?.lastName
                    )
              }
            />
          </div>
        ) : (
          t.common.na
        );
        return createdByUser;
      },
    },

    {
      name: t.workOrders.form.progress,
      sortField: "report.procedureCompletion",
      minWidth: "166px",

      sortable: true,
      cell: (row) => (
        <>
          <ProgressBar
            completed={
              row?.attributes?.report?.data?.attributes?.procedureCompletion
                ? row?.attributes?.report?.data?.attributes?.procedureCompletion
                : 0
            }
            bgColor="#4FAB68"
            isLabelVisible={false}
            height="6px"
            width="64px"
            baseBgColor="#E4E6EA"
            labelColor="#E4E6EA"
          />

          <span
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
            className="ml-3 mr-3"
          >
            {row?.attributes?.report?.data?.attributes?.procedureCompletion
              ? row?.attributes?.report?.data?.attributes?.procedureCompletion
              : 0}
            %
          </span>
        </>
      ),
    },
  ];

  columns = columns.filter((col) => col !== null);
  const curentUrl = useLocation();

  const queryParams = new URLSearchParams(curentUrl.search);
  const workOrderId = queryParams.get("id");

  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [fetching, setFetchLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [targetedData, setTargetedData] = useState();
  const [togglePreview, setTogglePreviw] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);

  const [refresh, setRefresh] = useState(false);
  const [loadUserData, setLoadUserData] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoadUserData(true);
      if (!(role === "super_admin")) {
        const userData = await getUserData(user.id);

        dispatch(props.fulfillUser(userData));
      }

      const fetchData = await dispatch(
        fetchWOInitData({ organisationId, role, allIds: [], currentUserId })
      );
      setLoadUserData(false);
      if (fetchData) {
        setFetchLoading(false);
        if (workOrderId) {
          const fetchAllData = await dispatch(
            fetchAllWOData({ organisationId, role, allIds: [], currentUserId })
          );

          let selectedWorkOrder = fetchAllData.payload.response.find(
            (each) => each?.attributes?.countId == workOrderId
          );
          if (selectedWorkOrder) {
            await dispatch(
              fetchWOWithFilter({
                organisationId,
                searchName: debounceValue,
                page: "1",
                pageSize: "25",
                assignee: filterOptions.people,
                status: filterOptions.status,
                priority: filterOptions.priority,
                category: filterOptions.categories,
                customers: filterOptions.customers,
                locations: filterOptions.locations,
                dueDate: selectedDates,
                serialNumber: filterOptions.serialNumber,
                teams: filterOptions.teams,
                sort: sortData,
                role: role,
                currentUserId,
                orderType: filterOptions?.orderType,
              })
            );
            setTargetedData(selectedWorkOrder);
            setTogglePreviw(true);
          }
        }
      }
    };

    fetchData();
  }, [workOrderId]);

  const priorityOptions = [
    {
      value: "none",
      label: t.workOrders.priority_status.none,
      color: null,
    },
    {
      value: "low",
      label: t.workOrders.priority_status.low,

      color: "#4FAB68",
    },
    {
      value: "medium",
      label: t.workOrders.priority_status.medium,

      color: "#E2B203",
    },
    {
      value: "high",
      label: t.workOrders.priority_status.high,

      color: "#D14040",
    },
  ];

  const statusOptions = [
    {
      value: "open",
      color: "blue",
      label: t.workOrders.work_order_status.open,
    },
    {
      value: "cancelled",
      color: "darkgrey",
      label: t.workOrders.work_order_status.cancel,
    },
    {
      value: "reOpen",
      color: "light-purple",
      label: t.workOrders.work_order_status.reOpen,
    },

    {
      value: "inProgress",
      color: "yellow",
      label: t.workOrders.work_order_status.inProgress,
    },
    {
      value: "onHold",
      color: "red",
      label: t.workOrders.work_order_status.onHold,
    },
    {
      value: "inReview",
      color: "green",
      label: t.workOrders.work_order_status.inReview,
    },
    {
      value: "completed",
      color: "darkblue",
      label: t.workOrders.work_order_status.completed,
    },
  ];
  const categoryOptions = [
    {
      value: "damage",
      label: t.workOrders.form.category_options[0],
    },
    {
      value: "corrective action Downtime",
      label: t.workOrders.form.category_options[1],
    },
    {
      value: "planned Downtime",
      label: t.workOrders.form.category_options[2],
    },
    {
      value: "unplanned Downtime",
      label: t.workOrders.form.category_options[3],
    },
    {
      value: "inspection",
      label: t.workOrders.form.category_options[4],
    },
    {
      value: "electrical",
      label: t.workOrders.form.category_options[5],
    },
    {
      value: "mechanical",
      label: t.workOrders.work_order_category.Mechanical,
    },
    {
      value: "HVAC",
      label: t.workOrders.work_order_category.HVAC,
    },
    {
      value: "preventive maintenance",
      label: t.workOrders.form.category_options[8],
    },
    {
      value: "project",
      label: t.workOrders.form.category_options[9],
    },
    {
      value: "safety",
      label: t.workOrders.work_order_category.Safety,
    },
    {
      value: "sop",
      label: t.workOrders.form.category_options[11],
    },
  ];
  const handleSetDataByFilter = (newData) => {};

  return (
    <>
      <div className="workOrder new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <WorkOrderIcon />
            {t.workOrders.title}
          </Header>
          <div></div>

          {userPermissions?.["work-order"]?.create && initData.length > 0 ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button"
            >
              <span className="add-button-text">
                {" "}
                {t.workOrders.details_view.work_order_no}
              </span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>

        {initData.length > 0 ? (
          <div className="new-listing-filter sticky-filter mt-8">
            <Filters
              data={initData}
              currentUserId={currentUserId}
              roleData={role}
              allIds={allIds}
              setDataByFilter={handleSetDataByFilter}
              hasStatus={false}
              fileData={data}
              setRefresh={setRefresh}
              refresh={refresh}
              setloader={setloader}
              loader={loader}
              setSearchTitle={setSearchTitle}
              searchTitle={searchTitle}
              filterOptions={filterOptions}
              debounceValue={debounceValue}
              setFilterOptions={setFilterOptions}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setSortData={setSortData}
              sortData={sortData}
            />
          </div>
        ) : null}
      </div>
      <div className="workOrder-container new-listing-container">
        {initLoading || loadUserData ? (
          <div className="d-flex animation-div justify-content-center align-items-center">
            <Animation />
          </div>
        ) : (
          <div>
            <div className="new-listing-filter">
              {initData.length > 0 ? (
                <>
                  <DataTable
                    className="datatable-div"
                    columns={columns}
                    fixedHeader
                    onSort={handleSort}
                    data={data}
                    noDataComponent={
                      initData.length > 0 ? (
                        <div className="no-data-container">
                          <div className="">
                            <p className="no-data-text">
                              {t.common.no_result_found}
                            </p>
                          </div>
                        </div>
                      ) : null
                    }
                    customStyles={customStyles}
                    direction={selectedLanguage === "en" ? "ltr" : "rtl"}
                    onRowClicked={(row) => {
                      setTargetedData(row);
                      setTogglePreviw(true);
                    }}
                    sortIcon={
                      sortData ? (
                        <div>
                          <span>
                            <SortIcon />
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveSorting();
                            }}
                          >
                            <CloseIcon />
                          </span>
                        </div>
                      ) : (
                        <span></span>
                      )
                    }
                    persistTableHead={true}
                    pointerOnHover={true}
                    highlightOnHover={true}
                    progressPending={loader}
                    progressComponent={
                      <div className="mt-8 mb-8 ">{t.common.loading}</div>
                    }
                  />

                  <div className="d-flex justify-content-end">
                    <Pagination
                      ofString={t.common.of}
                      total={total}
                      prevItem={
                        selectedLanguage === "en" ? (
                          <ArrowLeft />
                        ) : (
                          <ArrowRight />
                        )
                      }
                      nextItem={
                        selectedLanguage === "en" ? (
                          <ArrowRight />
                        ) : (
                          <ArrowLeft />
                        )
                      }
                      page={page}
                      limit={pageSize}
                      handleNext={async () => {
                        setloader(true);
                        await dispatch(
                          fetchWOWithFilter({
                            organisationId,
                            searchName: debounceValue,
                            page: page + 1,
                            pageSize: pageSize,
                            assignee: filterOptions.people,
                            status: filterOptions.status,
                            priority: filterOptions.priority,
                            category: filterOptions.categories,
                            customers: filterOptions.customers,
                            locations: filterOptions.locations,
                            dueDate: selectedDates,
                            serialNumber: filterOptions.serialNumber,
                            teams: filterOptions.teams,
                            sort: sortData,
                            role: role,
                            allIds: allIds,
                            currentUserId,
                            orderType: filterOptions?.orderType,
                          })
                        );
                        setloader(false);
                      }}
                      handlePrevious={async () => {
                        setloader(true);
                        await dispatch(
                          fetchWOWithFilter({
                            organisationId,
                            searchName: debounceValue,
                            page: page - 1,
                            pageSize: pageSize,
                            assignee: filterOptions.people,
                            status: filterOptions.status,
                            priority: filterOptions.priority,
                            category: filterOptions.categories,
                            customers: filterOptions.customers,
                            locations: filterOptions.locations,
                            dueDate: selectedDates,
                            serialNumber: filterOptions.serialNumber,
                            teams: filterOptions.teams,
                            sort: sortData,
                            role: role,
                            allIds: allIds,
                            currentUserId,
                            orderType: filterOptions?.orderType,
                          })
                        );
                        setloader(false);
                      }}
                    />
                  </div>
                </>
              ) : null}

              {initData.length == 0 ? (
                <div className="no-data-container">
                  <div className="no-work-orders pb-15">
                    <WorkOrderIconBlue />
                    <p className="no-data-text">
                      {t.common.there_no}{" "}
                      <span
                        className="link-text position-relative c-pointer"
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <Tooltip
                          color="#fff"
                          backgroundColor="#172B4D"
                          position={
                            selectedLanguage == "ar" ? "top right" : "top left"
                          }
                          show={showTooltip}
                          textBoxWidth={
                            selectedLanguage == "ar" ? "53px" : "165px"
                          }
                          arrowAlign={
                            selectedLanguage == "ar" ? "center" : "start"
                          }
                          fontSize="14px"
                          fontWeight="400"
                          fontFamily={
                            selectedLanguage == "ar"
                              ? "Noto Kufi Arabic"
                              : "Roboto"
                          }
                          padding="0px 0px 0px 8px"
                          borderRadius="5px"
                          static
                          moveRight="120px"
                          moveUp={selectedLanguage == "ar" ? "-1px" : "0px"}
                        >
                          <span className="work-order-tooltip">
                            {t.workOrders.how_to_add_WO}
                          </span>
                        </Tooltip>

                        {" " + t.workOrders.title + " "}
                      </span>{" "}
                      {t.common.added}
                    </p>
                    {userPermissions?.["work-order"]?.create ? (
                      <button
                        className="work-order-button-transparent"
                        onClick={() => {
                          setToggleAsideModal(true);
                        }}
                      >
                        {t.workOrders.add_work_orders}
                      </button>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}

        {/*  WO add modal */}
        <Add
          toggled={toggleAsideModal}
          untoggle={() => {
            setToggleAsideModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 633));
          }}
          currentUserId={currentUserId}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          roleData={role}
          allIds={allIds}
          setRefresh={setRefresh}
          refresh={refresh}
          setloader={setloader}
          loader={loader}
          setSearchTitle={setSearchTitle}
          searchTitle={searchTitle}
          filterOptions={filterOptions}
          debounceValue={debounceValue}
          setFilterOptions={setFilterOptions}
          setSelectedDates={setSelectedDates}
          selectedDates={selectedDates}
          setSortData={setSortData}
          sortData={sortData}
        />

        {/*  WO edit modal */}
        <Edit
          currentUserId={currentUserId}
          setTotalPartCount={setTotalPartCount}
          totalPartCount={totalPartCount}
          toggled={toggleEditModal}
          untoggle={() => {
            setToggleEditModal(false);
            setTargetedData();
            setModalWidth(Math.max(window.innerWidth / 2, 633));
            history.push("/work-orders");
          }}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          roleData={role}
          allIds={allIds}
          setRefresh={setRefresh}
          refresh={refresh}
          targetedData={targetedData}
          setSeriesEdit={setSeriesEdit}
          seriesEdit={seriesEdit}
          setloader={setloader}
          loader={loader}
          setSearchTitle={setSearchTitle}
          searchTitle={searchTitle}
          filterOptions={filterOptions}
          debounceValue={debounceValue}
          setFilterOptions={setFilterOptions}
          setSelectedDates={setSelectedDates}
          selectedDates={selectedDates}
          setSortData={setSortData}
          sortData={sortData}
        />

        {/*  WO view modal */}
        <Preview
          targetedData={targetedData}
          setTotalPartCount={setTotalPartCount}
          totalPartCount={totalPartCount}
          edit={() => {
            setTogglePreviw(false);
            setToggleEditModal(true);
          }}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          toggled={togglePreview}
          untoggle={() => {
            setTargetedData();
            setTotalPartCount({});
            setTogglePreviw(false);
            history.push("/work-orders");
          }}
          negative={isPastDue(
            targetedData?.attributes?.dueDate +
              "T" +
              `${targetedData?.attributes?.dueTime || "08:00:00"}`,
            targetedData?.attributes?.status
          )}
          startDue={isStartDue(
            targetedData?.attributes?.status,
            targetedData?.attributes?.startDate
          )}
          setRefresh={setRefresh}
          refresh={refresh}
          setSeriesEdit={setSeriesEdit}
          seriesEdit={seriesEdit}
          setloader={setloader}
          loader={loader}
          setSearchTitle={setSearchTitle}
          searchTitle={searchTitle}
          filterOptions={filterOptions}
          debounceValue={debounceValue}
          setFilterOptions={setFilterOptions}
          setSelectedDates={setSelectedDates}
          selectedDates={selectedDates}
          setSortData={setSortData}
          sortData={sortData}
          roleData={role}
          allIds={allIds}
        />
      </div>
    </>
  );
};

export default connect(null, auth.actions)(WorkOrders);
